import React, { useMemo, FC } from 'react';
import ErrorBoundary from './errorBoundary';

interface IProps {
  // 组件 templateCode -> 实际的组件
  components: Record<string, FC<any>>;
  blocks: Array<{
    // 组件 templateCode
    componentCode: string;
    // 该组件是否为 Layout 组件. 一个页面只能有一个 Layout 组件, 页面内其他组件会作为 Layout 组件的子组件来渲染
    isLayoutComponent: boolean;
    data: {
      iQuicInfo: {
        blockId: string;
        blockCode: string;
        templateCode: string;
        templateVersion: string;
      };
      $spm: {
        spma?: string;
        spmb?: string;
        spmc?: string;
        spmd?: Record<string, string>;
      };
      $bizTag: {
        spma?: string;
        spmb?: string;
        spmc?: string;
        spmd?: Record<string, string>;
      };
      // 其他组件自定义配置
      [props: string]: any;
    };
  }>;
}

export default function PageRender({ components, blocks }: IProps) {
  const renderBlocks = () => {
    return blocks.map(({ isLayoutComponent, componentCode, data }) => {
      if (isLayoutComponent) return null;
      const Component = components[componentCode];
      return (
        <ErrorBoundary key={componentCode}>
          <Component {...data} />
        </ErrorBoundary>
      );
    });
  };

  return <>{renderBlocks()}</>;
}
